import React from 'react';
import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import { confirmBonusClaimModalStyles as styles } from './confirmBonusClaimModal.tailwind';
import Button from '../../Button/Button';
import redeem_rewards from '../../../../assets/svgs/redeem_reward.svg';
import { useEffect } from 'react';
import { useState } from 'react';

const ConfirmBonusClaimModal = ({ isOpen, onClose, onClaim, bonusDetail }) => {
    const { claimingBonusPoint } = useSelector(state => state.earnPoint);

    const [dots, setDots] = useState('.');

    useEffect(() => {
        if (claimingBonusPoint) {
            const interval = setInterval(() => {
                setDots(prev => (prev.length >= 3 ? '' : prev + '.'));
            }, 300);
            return () => clearInterval(interval);
        } else {
            setDots('');
        }
    }, [claimingBonusPoint]);

    return (
        <Modal
            open={isOpen}
            onClose={() => {}}
            disableAutoFocus
        >
            <div className={styles.container}>
                {/* <img src={reward?.rewardIcon} alt='icon' /> */}
                <div className={styles.popupheading}>
                    <img src={redeem_rewards} alt="redeem_rewards" className={styles.redeem_rewards}></img>              
                    <div className={styles.heading}>Claim Bonus</div>
                </div>
                <div className={styles.description}>Are you sure you want to claim <span className={styles.highlightedText}>{`"${bonusDetail?.bonusTitle}"`}</span>
                     {bonusDetail?.pointsValue &&
                        <> for <span className={styles.highlightedText}>{bonusDetail?.pointsValue}</span> points</>
                     }?</div>
                <div className={styles.buttonContainer}>
                    <Button variant="primary" className={`!bg-white ${styles.button1}`} onClick={onClose} disabled={claimingBonusPoint}>
                        Cancel
                    </Button>
                    <Button variant="theme" className={styles.button} onClick={onClaim} disabled={claimingBonusPoint}>
                        {claimingBonusPoint ? `Claiming${dots}` : `Claim`}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default ConfirmBonusClaimModal